<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <span class="ivu-page-header-title">{{$route.meta.title}}</span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="userForm" :model="userForm"  :label-width="75" label-position="right" @submit.native.prevent>
        <Row type="flex" :gutter="24">
          <Col v-bind="grid">
            <FormItem label="文章名称："  label-for="key">
              <Input search enter-button placeholder="请输入" clearable v-model="userForm.key" @on-search="userSearchs">
              </Input>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <Table :columns="columns2" :data="userInfo" ref="table" class="ivu-mt"
             :loading="loading"
             no-userFrom-text="暂无数据"
             no-filtered-userFrom-text="暂无筛选结果"
      >
        <template slot-scope="{ row, index }" slot="action">
          <a @click="edit(row.id)">编辑</a>
        </template>
      </Table>
      <Page :total="dataCount" :current="userForm.page" :page-size="userForm.limit" class="acea-row row-right page" show-total  @on-change="changepage"></Page>
    </Card>
  </div>
</template>

<script>
import { articleList } from '@/api/article'
export default {
  name: 'articleList',
  inject: ['reload'],
  data () {
    return {
      userForm: {
        page: 1,
        limit: 10,
        type: 1,
        key: ''
      },
      grid: {
        xs: 24,
        sm: 24,
        md: 12,
        lg: 7,
        xl: 7
      },
      article_id: 0,
      editShow: false,
      dataCount: 0,
      userInfo: [],
      loading: false,
      userid: 0,
      columns2: [
        {
          title: '文章标题',
          key: 'title',
          minWidth: 120
        },
        {
          title: '创建时间',
          key: 'ctime',
          minWidth: 120
        },
        {
          title: '操作',
          slot: 'action',
          fixed: 'right',
          minWidth: 120
        }
      ]
    }
  },
  created () {
    this.articleList()
  },
  methods: {
    articleList () {
      this.loading = true
      articleList(this.userForm).then(res => {
        let data = res.data
        this.userInfo = data.list
        this.dataCount = data.count
        this.loading = false
      }).catch(res => {
        this.loading = false
        this.$Message.error(res.msg)
      })
    },
    // 分页
    changepage (status) {
      this.userForm.page = status
      this.articleList()
    },
    // 表格搜索
    userSearchs () {
      this.userForm.page = 1
      this.articleList()
    },
    selectChange () {
      this.userForm.key = ''
    },
    edit (id) {
      this.$router.push({ path: '/admin/article/form/' + id })
    },
    updateStatusModel (modalStatus) {
      this.editShow = modalStatus
      this.reload()
    }
  }
}
</script>
